module.exports = __webpack_public_path__ + "img/icon-external-link.326bc516.svg";